import * as Yup from 'yup';

export const WaitingListSchema = Yup.object().shape({
  email: Yup.string().email('Invalid email').required('Required'),
  name: Yup.string().min(2, 'Too Short!').max(50, 'Too Long!'),
  postcode: Yup.number().min(5).required('Required'),
});
